/* THUNDER HONEY V3 product page, Shopify. Generated by _th-v3-tools/pdp_sections.py, do not edit here:
   1. the page script of _deploy_baseline/_v3/pdp.html (the buy bar, the cookie banner offset, the ingredient chips),
      reading the Shopify cookie banner (#thcb) as well as the static one (.th-ck)
   2. _th-v3-tools/product_extra.js (Shopify only: add to cart through THCart, the review list) */
/* layout A page script: 1. the buy bar shows once the buy box button is above the screen; 2. on phones the bar sits on top of the slim
   cookie banner (its height lands in --pp-ck; on desktop the banner steps up instead, in CSS); 3. the ingredient chips filter the card row to one tag. */
(function () {
  var d = document, root = d.documentElement;
  var bar = d.querySelector('.pp-sb'), cta = d.querySelector('#p-buy .pb-cta');
  if (bar && cta) {
    /* a scroll check, not an IntersectionObserver: a jump link or a fast fling can carry the button past the screen without it ever intersecting */
    root.classList.add('pp-js');
    var sbq = 0, sb = function () { sbq = 0; bar.classList.toggle('is-on', cta.getBoundingClientRect().bottom < 0); };
    addEventListener('scroll', function () { if (!sbq) sbq = requestAnimationFrame(sb); }, { passive: true });
    addEventListener('resize', sb); sb();
  }
  var ro = null, seen = null;
  function ck() {
    var b = d.querySelector('.th-ck, #thcb'), h = 0;
    if (b && innerWidth < 700) { var r = b.getBoundingClientRect(); if (r.height) h = Math.max(0, Math.round(innerHeight - r.top)); }
    root.style.setProperty('--pp-ck', h + 'px');
    if (b && b !== seen && 'ResizeObserver' in window) { if (ro) ro.disconnect(); ro = new ResizeObserver(ck); ro.observe(b); seen = b; }
  }
  new MutationObserver(ck).observe(d.body, { childList: true });
  addEventListener('resize', ck); ck();
  var t = d.getElementById('p-inside-track'), btns = [].slice.call(d.querySelectorAll('[data-grp-go]'));
  if (t && btns.length) {
    /* the chips filter the card row: a card shows when its data-grp holds the chip's tag ("All" shows every card) */
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-grp-go');
        [].forEach.call(t.children, function (li) {
          var on = k === 'all' || (' ' + li.getAttribute('data-grp') + ' ').indexOf(' ' + k + ' ') > -1;
          li.classList.toggle('is-off', !on);
        });
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        t.scrollTo({ left: 0, behavior: 'auto' });
      });
    });
  }
})();

/* ================= Shopify only, the V3 product page (_th-v3-tools/product_extra.js) =================
   Edit it here; pdp_sections.py appends it to assets/th-v3-product.js after the static page's own script.
   The plan chooser itself is th-v3-base.js ([data-plan], [data-plan-cta], [data-plan-price]). This part:
   1. keeps the hidden product form (Shopify's items[] syntax) in step with the chosen plan: quantity, selling plan, and
      the free welcome kit (items[1]) only with a subscription. That form is what a visitor without JavaScript posts;
   2. turns the add-to-cart button (outside the form, form="pb-form") into a plain button, so no submit event fires and
      the Google tag records no form_start or form_submit for an add to cart (the live product page records none either);
   3. adds the chosen plan through window.THCart (th-v3-cart.js): /cart/add.js with the selling plan and quantity
      (3 pouches on the 90-day plan), the free welcome kit with a subscription, then the V3 cart drawer. The buy box
      button, the buy bar and the first-90-days buttons ([data-pb-add]) all go this way. Without THCart the button posts
      the form and the links follow their /cart/add URL;
   4. opens the full review list (the Judge.me widget, #judgeme_product_reviews) from any link to it, from the Judge.me
      star badge in the buy box (click, Enter or Space, taken before Judge.me's own handler, which would scroll the widget
      under the fixed header), or when the page opens on that address;
   5. a ?plan=p30 or ?plan=p90 link picks that plan and brings the plan cards into view, as on the live product page
      (figma-site.js, used by the "Start with 30 days" and "Start with 90 days" links). Any other value keeps the default plan. */
(function () {
  'use strict';
  var d = document, w = window;

  /* 4. the review list */
  var all = d.querySelector('[data-rv-all]'), jm = d.getElementById('judgeme_product_reviews');
  if (all && jm) {
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var openAll = function (go) {
      all.classList.add('is-open');
      if (go) jm.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    };
    if (location.hash === '#judgeme_product_reviews') openAll(true);
    d.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href="#judgeme_product_reviews"]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      openAll(true);
      try { history.replaceState(null, '', '#judgeme_product_reviews'); } catch (x) {}
    });
    var badge = function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (!e.target.closest || !e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge')) return;
      e.preventDefault();
      e.stopPropagation(); /* Judge.me's own handler would scroll again, to its own offset under the fixed header */
      openAll(true);
    };
    d.addEventListener('click', badge, true);
    d.addEventListener('keydown', badge, true);
  }

  var form = d.querySelector('[data-pb-form]');
  if (!form) return;
  var idEl = form.querySelector('[data-pb-id]');
  var qty = form.querySelector('[data-pb-qty]');
  var sp = form.querySelector('[data-pb-sp]');
  var kit = form.querySelectorAll('[data-pb-kit]');
  var cta = d.querySelector('#p-buy [data-plan-cta]');

  function plan(key) {
    if (key) return d.querySelector('#p-buy [data-plan="' + key + '"]');
    return d.querySelector('#p-buy [data-plan].is-on') || d.querySelector('#p-buy [data-plan]');
  }

  /* 1. the hidden form follows the chosen plan */
  function sync() {
    var p = plan();
    if (!p || !qty || !sp) return;
    qty.value = p.getAttribute('data-qty') || '1';
    var s = p.getAttribute('data-sp') || '';
    sp.value = s;
    sp.disabled = !s;
    [].forEach.call(kit, function (k) { k.disabled = !s; });
  }
  if ('MutationObserver' in w) {
    var mo = new MutationObserver(sync);
    [].forEach.call(d.querySelectorAll('#p-buy [data-plan]'), function (p) { mo.observe(p, { attributes: true, attributeFilter: ['class'] }); });
  }
  sync();

  /* 5. the ?plan= link: a click on the card, so th-v3-base.js updates the button price and the form follows (sync above) */
  var want = '';
  try { want = new URLSearchParams(w.location.search).get('plan') || ''; } catch (x) {}
  var wantEl = want === 'p30' || want === 'p90' ? plan(want.slice(1)) : null;
  if (wantEl) {
    wantEl.click();
    setTimeout(function () {
      var box = wantEl.closest ? wantEl.closest('.plans') : null;
      var still = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (box) box.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
    }, 150);
  }

  /* 3. add through THCart; false when THCart is missing, so the caller falls back to the plain request */
  function add(p, el) {
    if (!w.THCart || !p || !idEl) return false;
    if (el && el.getAttribute('aria-busy') === 'true') return true;
    var o = { id: parseInt(idEl.value, 10), quantity: parseInt(p.getAttribute('data-qty'), 10) || 1 };
    var s = p.getAttribute('data-sp');
    if (s) o.selling_plan = parseInt(s, 10);
    if (el) { el.classList.add('is-busy'); el.setAttribute('aria-busy', 'true'); }
    w.THCart.add(o).catch(function () { /* the drawer shows Shopify's message */ }).then(function () {
      if (el) { el.classList.remove('is-busy'); el.removeAttribute('aria-busy'); }
    });
    return true;
  }

  /* 2. a plain button: no form association, so no submit event and no form interaction for the Google tag */
  if (cta && !cta.disabled) {
    cta.type = 'button';
    cta.removeAttribute('form');
    cta.addEventListener('click', function () {
      if (add(plan(), cta)) return;
      sync();
      form.submit(); /* THCart failed to load: post the same items[] a visitor without JavaScript posts */
    });
  }

  /* a submit that still reaches the form (for example Enter in an injected field) goes through THCart too */
  form.addEventListener('submit', function (e) {
    if (add(plan(), cta)) e.preventDefault();
  });

  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-pb-add]') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    if (add(plan(a.getAttribute('data-pb-add')), a)) e.preventDefault();
  });
})();
